"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.number.constructor");




































































var _user = require("@/utils/user");
var _taskSkillMap = _interopRequireDefault(require("./taskSkillMap")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'TaskSkillPoint', components: { TaskSkillMap: _taskSkillMap.default }, props: { taskId: { type: Number }, mapId: { type: String } }, data: function data() {return { tableData: [], taskPosData: [], // 列表数据
      groupList: ['A', 'B', 'C', 'E', 'F'], skillListData: [], addPos: false, title: '', delIndex: '', searchData: { page: 1, pageSize: 100, // 页码条数
        rows: 10 }, addData: { skillId: '', taskId: '', flowId: '', groups: '', mapId: '', stayTime: '' }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'positionName', label: '(始巡点)', isShow: true }, { prop: 'endPositionName', label: '终巡点', formatter: function formatter(row, column, cellValue) {if (row.flowType === 0) {return '';} else {return cellValue;}}, isShow: true }, { prop: 'flowType', label: '类别', formatter: function formatter(row, column, cellValue) {return cellValue ? '段' : '点';}, isShow: true }], rules: { skillId: [{ required: true,
          message: '请选择技能',
          trigger: 'blur' }],

        groups: [{
          required: true,
          message: '请选择分组',
          trigger: 'blur' }] } };



  },
  mounted: function mounted() {
    var self = this;
    self.handleGetData(self.taskId, self.mapId);
  },
  methods: {
    handleGetData: function handleGetData(taskId, mapId) {
      var self = this;
      // self.taskId = taskId
      self.addData.taskId = taskId;
      self.addData.mapId = mapId;
      console.log('point:' + taskId + ',' + mapId);
      var path = '/api/temi/robot/task/' + taskId + '/flow?mapId=' + mapId;
      self.getData(path, {}, function (res) {
        self.tableData = res;
        if (self.$refs.skillMap) {
          self.$refs.skillMap.handleGetPointList(res);
        }
      });
      // 获取Map信息
      if (self.$refs['skillMap']) {
        self.$refs.skillMap.handleGetMapInfo(mapId, taskId);
        self.$refs.skillMap.getMapPosList(mapId);
      }
    },
    handleGetPointList: function handleGetPointList(mapId) {
      var self = this;
      this.handleGetData(self.addData.taskId, mapId);
    },
    handleRowClick: function handleRowClick(row, column, event) {
      console.log(row);
      this.$emit('handleGetParams', row.paramList);
    },
    handleSetSkillParam: function handleSetSkillParam(flowId) {
      this.$emit('handleSetSkillParamShow', flowId);
    },
    checkPermission: _user.checkPermission,
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addPos = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addPos'].resetFields();
      this.cleanData();
      this.addPos = false;
    },
    updateMenu: function updateMenu(pos) {// 修改操作
      this.title = '设置停留时间';
      var self = this;
      self.addPos = true;
      self.addData.id = pos.id;
      self.addData.stayTime = pos.stayTime;
    },
    handleSetStayTime: function handleSetStayTime() {// 新增提交操作
      var self = this;
      self.$refs.addPos.validate(function (valid) {
        if (valid) {
          console.log(self.addData);
          var taskId = self.addData.taskId;
          var path = '/api/temi/robot/task/' + taskId + '/flow';
          self.postData(path, [{ 'id': self.addData.id, 'stayTime': self.addData.stayTime }], function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.handleGetData(taskId, self.addData.mapId);
          });
        } else {
          return false;
        }
      });
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addPos.validate(function (valid) {
        if (valid) {
          console.log(self.addData);
          var taskId = self.addData.taskId;
          var flowId = self.addData.flowId;
          var path = '/api/temi/robot/task/' + taskId + '/flow/' + flowId + '/taskSkill';
          self.postData(path, self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.handleGetData(taskId, self.addData.mapId);
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(flowId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        var path = '/api/temi/robot/task/' + self.addData.taskId + '/flow/' + flowId;
        self.delData(path, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          console.log(self.addData);
          self.handleGetData(self.addData.taskId, self.addData.mapId);
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addPos = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData.name = '';
    } } };exports.default = _default;